export default {
  state: {
    CreateProfileData: {},
  },

  getters: {
    getCreateProfileData(state) {
      return state.CreateProfileData;
    },
  },

  mutations: {
    setCreateProfileData(state, data) {
      const isNull = data === null;

      state.CreateProfileData = {
        id: !isNull ? data.id : "",
        name: !isNull ? data.name : "",
        description: !isNull ? data.description : "",
      };
    },
  },

  actions: {
    changeCreateProfileData(context, infos) {
      context.commit("setCreateProfileData", infos);
    },
  },
};
